import './index.scss'
import React from 'react'
import Base from '../base'

export default class Blog extends Base {
  render() {
    return (
      <div className="section-collection-articles articles-layout-blog">
        <div className="container">
          {this.state.articles.map((article, index) =>
            <a href={article.path || ""} className="collection-article-item" key={"article-" + article.guid + index}>
              <div style={{marginBottom: 15}}>{article.title}</div>
              <div>
                {
                  (article.cover || {}).url &&
                  <img style={{width: '100%'}} src={article.cover.url+"?imageMogr2/format/jpeg"} />
                }
              </div>
            </a>
          )}

          {super.render()}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/section/collection/articles/blog/index.js